export function referralsCounterHelper (count) {
  if (!count) {
    return '!'
  }
  return count <= 99
    ? count
    : '+99'
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/referral-history.helper.js